/**
 * @author Shalini Jha
 * @name OngoingUploads
 * @description A component renders the list of ongoing uploads
 */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import ProgressBar from '../ProgressBar';
import styles from './BulkUpload.module.css';
import { Utilities } from '@gscope-mfe/app-bridge';
const { generateRandomKey } = Utilities;
/**
 * @namee getUploadedPercent
 * @param {Object} summary
 * @desc Get Percentage for uploading
 */

export const getUploadedPercent = (summary) => Math.round((summary.processed / summary.total) * 100);
/**
 * @name renderProgressBar
 * @desc Renders the progress bar for uploading file
 * @param {*} fileList
 */

export const renderProgressBar = (fileList) =>
    fileList.map((file) => {
        const uploadedPercent = getUploadedPercent(file.summary) || 0;
        return (
            <React.Fragment key={generateRandomKey()}>
                <div className={styles.ongoingUpload_fileDetails}>
                    <div>
                        <div>{file.fileName}</div>
                        <div className={styles.ongoingUpload_timeStamp}>
                            {moment(file.uploadDate).format('MMM Do YYYY, HH:mm')}
                        </div>{' '}
                    </div>
                    <span className={styles.ongoingUpload_uploadPercent}>{uploadedPercent}%</span>
                </div>
                <ProgressBar value={uploadedPercent} />
            </React.Fragment>
        );
    });

const OngoingUploads = ({ fileList }) => (
    <div className={styles.ongoingUpload_uploadListContainer}>{fileList.length > 0 && renderProgressBar(fileList)}</div>
);

OngoingUploads.propTypes = {
    fileList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
export default OngoingUploads;
